'use strict'
import { App, View } from '../../config/app.js'
import { Modal } from '../../modal.js'

export default function ()
{
	App.Modal.Login = new Modal('Login')
}
